"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transactionalLoanRecordSchema = void 0;
var application_score_card_schema_1 = require("./application-score-card-schema");
var auto_referral_schema_1 = require("./auto-referral-schema");
exports.transactionalLoanRecordSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        /* eslint-disable-next-line no-template-curly-in-string */
        errorMessage: '- should not have additional property ${0#}',
    },
    required: [
        'transactionalLoanRecordID',
        'cmhcAccountNumber',
        'applicationIDTimestamp',
        'annualHeatingCostAmount',
        'annualShelterPaymentAmount',
        'applicationCancellationIndicator',
        'applicantSourceIncomeTypeCode',
        'applicantTypeCode',
        'approvedLenderID',
        'liquidAssetsEquityIndicator',
        'builderLegalName',
        'blendedAmortizationIndicator',
        'bankAccountIndicator',
        'bankClientPeriod',
        'bankCardIndicator',
        'borrowerIndustrySectorID',
        'borrowerEmploymentOccupationTypeCode',
        'borrowerEquityAmount',
        'totalBorrowerIncomeAmount',
        'businessSourceID',
        'coBorrowerIndustrySectorID',
        'coBorrowerEmploymentOccupationTypeCode',
        'constructionImprovementCostAmount',
        'contactLocalTelephoneAreaCode',
        'contactLocalTelephoneExtensionNumber',
        'contactLocalTelephoneNumber',
        'coBorrowerCurrentEmploymentPeriod',
        'coBorrowerResidenceOccupancyPeriod',
        'cashEquityIndicator',
        'costableUnitID',
        'currentEmploymentPeriod',
        'residentialAccommodationStatusTypeCode',
        'dependentCount',
        'dwellingTypeCode',
        'employmentIndustryPeriod',
        'energyEfficientIndicator',
        'environmentalHazardIndicator',
        'federalConstituencyID',
        'financialInstitutionContactName',
        'finalApplicationStatusTypeCode',
        'financialInstitutionID',
        'liveableFloorAreaMeasurementCount',
        'flexibleDownpaymentIndicator',
        'garageSizeTypeCode',
        'garageTypeCode',
        'grossDebtServiceRatioPercent',
        'giftEquityIndicator',
        'heatingTypeCode',
        'homeBuilderInsuredProgressAdvanceProcessIndicator',
        'housingStructureTypeCode',
        'installmentCompletionTypeCode',
        'interestTypeCode',
        'lineOfCreditApplicationTypeCode',
        'lineOfCreditIndicator',
        'lineOfCreditRepaymentOptionTypeCode',
        'languageCorrespondenceTypeCode',
        'propertyLocationLegalDescriptionEnglish',
        'lenderSuppliedApplicationTypeCode',
        'lenderLoanAmount',
        'lenderLoanNumber',
        'propertyLendingValue',
        'loanAmortizationPeriod',
        'lenderAppraisalSourceTypeCode',
        'loanInterestRate',
        'loanPurposeTypeCode',
        'loanToValueRatioPercent',
        'loanSecurityTypeCode',
        'loanSpecialConditionIndicator',
        'loanTermPeriod',
        'loanTypeCode',
        'lotSizeSquareMetreCount',
        'lowRatioApplicationInsurableIndicator',
        'lowRatioMortgageTypeCode',
        'metropolitanMajorAreaID',
        'marketValueImprovedAmount',
        'marketTypeCode',
        'propertyMarketValueAmount',
        'mortgageAdvanceAmount',
        'mortgageAdvanceItemNumber',
        'maritalStatusTypeCode',
        'financialInstitutionCivicMunicipalityNameKey',
        'newExistingBuildingTypeCode',
        'residenceOccupancyTypeCode',
        'cmhcOfficeID',
        'onReserveTrustID',
        'originalApplicationStatusTypeCode',
        'originalRepresentativeAreaID',
        'originalRepresentativeFirstName',
        'originalRepresentativeLocalTelephoneNumber',
        'originalRepresentativeLastName',
        'originalRepresentativeTelephoneExtensionNumber',
        'outstandingBalanceExistingMortgageAmount',
        'otherEquityIndicator',
        'otherFinancingIndicator',
        'loanPortabilityApplicationTypeCode',
        'previousCmhcAccountNumber',
        'premiumChargedLoanIndicator',
        'propertyConstructionPeriod',
        'productTrackerID',
        'propertyAddressUnitNumber',
        'propertyAddressPostalCode',
        'propertyAddressMunicipalityName',
        'propertyAddressStreetDirectionID',
        'propertyAddressStreetName',
        'propertyAddressStreetNumber',
        'propertyAddressStreetTypeID',
        'propertyTaxAmount',
        'provinceID',
        'propertyImprovementIndicator',
        'propertySaleEquityIndicator',
        'partialPremiumDueAmount',
        'recordCreatedTimestamp',
        'recordUpdatedTimestamp',
        'recordUpdatedUserID',
        'residenceOccupancyPeriod',
        'refinanceTopUpAmount',
        'mortgageRepaymentTypeCode',
        'registeredRetirementSavingsPlanEquityIndicator',
        'statisticsCanadaCensusDivisionID',
        'statisticsCanadaCensusSubdivisionID',
        'statisticsCanadaProvinceID',
        'secondarySubmittedIndicator',
        'selfDirectedRegisterRetirementSavingsPlanIndicator',
        'selfEmployedSimplifiedIndicator',
        'propertySellingPriceAmount',
        'serviceTypeCode',
        'streetNameKeyCode',
        'savingsInvestmentAccountIndicator',
        'sweatEquityIndicator',
        'totalDebtServiceRatioPercent',
        'tenureTypeCode',
        'transmissionSourceGroupTypeCode',
        'transmissionSourceTypeCode',
        'financialInstitutionTransitNumber',
        'totalUnitCount',
        'urbanRuralID',
    ],
    properties: {
        transactionalLoanRecordID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        cmhcAccountNumber: {
            type: 'integer',
            minimum: 0,
            maximum: 999999999999,
            errorMessage: 'should be a number with up to 12 digits',
        },
        applicationIDTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        annualHeatingCostAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        annualShelterPaymentAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        applicationCancellationIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        applicantSourceIncomeTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        applicantTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        approvedLenderID: {
            type: 'string',
            minLength: 0,
            maxLength: 5,
            errorMessage: 'should have maximum length of 5 characters',
        },
        liquidAssetsEquityIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        builderLegalName: {
            type: 'string',
            minLength: 0,
            maxLength: 70,
            errorMessage: 'should have variable length up to 70 characters',
        },
        blendedAmortizationIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        bankAccountIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        bankClientPeriod: {
            type: 'string',
            minLength: 0,
            maxLength: 4,
            errorMessage: 'should have maximum length of 4 characters',
        },
        bankCardIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        borrowerIndustrySectorID: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        borrowerEmploymentOccupationTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        borrowerEquityAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        totalBorrowerIncomeAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        businessSourceID: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        coBorrowerIndustrySectorID: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        coBorrowerEmploymentOccupationTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        constructionImprovementCostAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        contactLocalTelephoneAreaCode: {
            type: 'string',
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        contactLocalTelephoneExtensionNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 10,
            errorMessage: 'should have maximum length of 10 characters',
        },
        contactLocalTelephoneNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 7,
            errorMessage: 'should have maximum length of 7 characters',
        },
        coBorrowerCurrentEmploymentPeriod: {
            type: 'string',
            minLength: 0,
            maxLength: 4,
            errorMessage: 'should have maximum length of 4 characters',
        },
        coBorrowerResidenceOccupancyPeriod: {
            type: 'string',
            minLength: 0,
            maxLength: 4,
            errorMessage: 'should have maximum length of 4 characters',
        },
        cashEquityIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        costableUnitID: {
            type: 'string',
            minLength: 0,
            maxLength: 4,
            errorMessage: 'should have maximum length of 4 characters',
        },
        currentEmploymentPeriod: {
            type: 'string',
            minLength: 0,
            maxLength: 4,
            errorMessage: 'should have maximum length of 4 characters',
        },
        residentialAccommodationStatusTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        dependentCount: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        dwellingTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        employmentIndustryPeriod: {
            type: 'string',
            minLength: 0,
            maxLength: 4,
            errorMessage: 'should have maximum length of 4 characters',
        },
        energyEfficientIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        environmentalHazardIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        federalConstituencyID: {
            type: 'string',
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        financialInstitutionContactName: {
            type: 'string',
            minLength: 0,
            maxLength: 35,
            errorMessage: 'should have variable length up to 35 characters',
        },
        finalApplicationStatusTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        financialInstitutionID: {
            type: 'string',
            minLength: 3,
            maxLength: 3,
            errorMessage: 'should be a string of length 3 characters',
        },
        liveableFloorAreaMeasurementCount: {
            type: 'number',
            maximum: 99999,
            minimum: 0,
            errorMessage: 'should be a number with up to 5 digits in total',
        },
        flexibleDownpaymentIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        garageSizeTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        garageTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        grossDebtServiceRatioPercent: {
            type: 'number',
            maximum: 999,
            minimum: -999,
            multipleOf: 0.0001,
            errorMessage: 'should be a decimal with up to 7 digits in total and 4 digits of precision',
        },
        giftEquityIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        heatingTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        homeBuilderInsuredProgressAdvanceProcessIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        housingStructureTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        installmentCompletionTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        interestTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        lineOfCreditAmortizationStartDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        lineOfCreditApplicationTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        lineOfCreditIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        lineOfCreditRepaymentOptionTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        languageCorrespondenceTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        propertyLocationLegalDescriptionEnglish: {
            type: 'string',
            minLength: 0,
            maxLength: 60,
            errorMessage: 'should have maximum length of 60 characters',
        },
        lenderSuppliedApplicationTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        lenderLoanAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        lenderLoanNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 20,
            errorMessage: 'should have variable length up to 20 characters',
        },
        propertyLendingValue: {
            type: 'number',
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        loanAmortizationPeriod: {
            type: 'string',
            minLength: 0,
            maxLength: 4,
            errorMessage: 'should have maximum length of 4 characters',
        },
        lenderAppraisalSourceTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        loanInterestRate: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            multipleOf: 0.0001,
            errorMessage: 'should be a decimal with up to 7 digits in total and 4 digits of precision',
        },
        loanPurposeTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        loanToValueRatioPercent: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 5 digits in total and 2 digits of precision',
        },
        loanSecurityTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        loanSpecialConditionIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        loanTermPeriod: {
            type: 'string',
            minLength: 0,
            maxLength: 4,
            errorMessage: 'should have maximum length of 4 characters',
        },
        loanTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        lotSizeSquareMetreCount: {
            type: 'integer',
            minimum: 0,
            maximum: 2147483648,
            errorMessage: 'should be an integer between 0 and 2147483648',
        },
        lowRatioApplicationInsurableIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        lowRatioMortgageTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        metropolitanMajorAreaID: {
            type: 'string',
            minLength: 0,
            maxLength: 4,
            errorMessage: 'should have maximum length of 4 characters',
        },
        marketValueImprovedAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        marketTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        propertyMarketValueAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        mortgageAdvanceAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        mortgageAdvanceItemNumber: {
            type: 'integer',
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767',
        },
        maritalStatusTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        financialInstitutionCivicMunicipalityNameKey: {
            type: 'string',
            minLength: 0,
            maxLength: 5,
            errorMessage: 'should have maximum length of 5 characters',
        },
        newExistingBuildingTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        residenceOccupancyTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        cmhcOfficeID: {
            type: 'string',
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        onReserveTrustID: {
            type: 'string',
            minLength: 0,
            maxLength: 4,
            errorMessage: 'should have maximum length of 4 characters',
        },
        originalApplicationStatusTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        originalRepresentativeAreaID: {
            type: 'string',
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        originalRepresentativeFirstName: {
            type: 'string',
            minLength: 0,
            maxLength: 15,
            errorMessage: 'should have maximum length of 15 characters',
        },
        originalRepresentativeLocalTelephoneNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 7,
            errorMessage: 'should have maximum length of 7 characters',
        },
        originalRepresentativeLastName: {
            type: 'string',
            minLength: 0,
            maxLength: 20,
            errorMessage: 'should have maximum length of 20 characters',
        },
        originalRepresentativeTelephoneExtensionNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 10,
            errorMessage: 'should have maximum length of 10 characters',
        },
        outstandingBalanceExistingMortgageAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        otherEquityIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        otherFinancingIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        loanPortabilityApplicationTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        previousCmhcAccountNumber: {
            type: 'integer',
            minimum: 0,
            maximum: 2147483648,
            errorMessage: 'should be an integer between 0 and 2147483648',
        },
        premiumChargedLoanIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        propertyConstructionPeriod: {
            type: 'string',
            minLength: 0,
            maxLength: 4,
            errorMessage: 'should have maximum length of 4 characters',
        },
        productTrackerID: {
            type: 'string',
            minLength: 0,
            maxLength: 5,
            errorMessage: 'should have maximum length of 5 characters',
        },
        propertyAddressUnitNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 6,
            errorMessage: 'should have maximum length of 6 characters',
        },
        propertyAddressPostalCode: {
            type: 'string',
            minLength: 0,
            maxLength: 6,
            errorMessage: 'should have maximum length of 6 characters',
        },
        propertyAddressMunicipalityName: {
            type: 'string',
            minLength: 0,
            maxLength: 20,
            errorMessage: 'should have variable length up to 20 characters',
        },
        propertyAddressStreetDirectionID: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        propertyAddressStreetName: {
            type: 'string',
            minLength: 0,
            maxLength: 30,
            errorMessage: 'should have variable length up to 30 characters',
        },
        propertyAddressStreetNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 7,
            errorMessage: 'should have maximum length of 7 characters',
        },
        propertyAddressStreetTypeID: {
            type: 'string',
            minLength: 0,
            maxLength: 6,
            errorMessage: 'should have maximum length of 6 characters',
        },
        propertyTaxAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        provinceID: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        propertyImprovementIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        propertySaleEquityIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        partialPremiumDueAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        previousSaleClosingDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        previousSalePriceAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        recordCreatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedUserID: {
            type: 'string',
            minLength: 0,
            maxLength: 8,
            errorMessage: 'should have maximum length of 8 characters',
        },
        residenceOccupancyPeriod: {
            type: 'string',
            minLength: 0,
            maxLength: 4,
            errorMessage: 'should have maximum length of 4 characters',
        },
        refinanceTopUpAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        mortgageRepaymentTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        registeredRetirementSavingsPlanEquityIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        statisticsCanadaCensusDivisionID: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        statisticsCanadaCensusSubdivisionID: {
            type: 'string',
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        statisticsCanadaProvinceID: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        secondarySubmittedIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        selfDirectedRegisterRetirementSavingsPlanIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        selfEmployedSimplifiedIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        propertySellingPriceAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        serviceTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        saleClosingDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        streetNameKeyCode: {
            type: 'string',
            minLength: 0,
            maxLength: 10,
            errorMessage: 'should have maximum length of 10 characters',
        },
        savingsInvestmentAccountIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        sweatEquityIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        totalDebtServiceRatioPercent: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            multipleOf: 0.0001,
            errorMessage: 'should be a decimal with up to 7 digits in total and 4 digits of precision',
        },
        tenureTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        transmissionSourceGroupTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        transmissionSourceTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        financialInstitutionTransitNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 5,
            errorMessage: 'should have maximum length of 5 characters',
        },
        totalUnitCount: {
            type: 'number',
            maximum: 99999,
            minimum: 0,
            errorMessage: 'should be a number with up to 5 digits in total',
        },
        urbanRuralID: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        applicationScoreCard: application_score_card_schema_1.applicationScoreCardSchema,
        autoReferral: {
            type: ['array', 'null'],
            items: auto_referral_schema_1.autoReferralSchema,
        },
    },
};
